/* eslint-disable linebreak-style */
import React from 'react';
import PropTypes from 'prop-types';
import NavLink from 'components/NavLink';
import Box from 'base-ui/dist/Box';
import Heading from 'base-ui/dist/Heading';
import { intl } from 'components/LocaleProvider';
import messages from './messages';

const getConfig = require('next/config').default;

const { publicRuntimeConfig = {} } = getConfig ? getConfig() : {};

const SymptomsBox = ({ symptoms }) => (
  <Box className="box-symptoms margin-top-big margin-bottom-big padding-normal">
    <Heading type="h3" className="titleLine">{intl.formatMessage(messages.exploreSymptoms)}</Heading>
    {symptoms.map((item) => (
      <NavLink
        key={item.id}
        basePath={publicRuntimeConfig.PUBLIC_URL}
        as={`${item.permalink}`}
        to={`/tag?permalink=${item?.permalink}`}
        routerStrategy={'next'}
        className={'btn main-bg rounded white-color'}
      >
        {item.name}
      </NavLink>
    ))}
  </Box>
);

SymptomsBox.propTypes = {
  symptoms: PropTypes.array
};

SymptomsBox.defaultProps = {
  symptoms: []
};

export default SymptomsBox;
